import script from "./StepCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StepCard.vue?vue&type=script&setup=true&lang=js"

import "./StepCard.vue?vue&type=style&index=0&id=008682f8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008682f8"]])

export default __exports__